<div class="contact-panel__item">
  <div class="contact-panel__item--wrapper">
    <div *ngIf="item.photo?.value" class="contact-panel__item-image">
      <img
        *ngIf="loadMedia"
        src="{{ item.photo.value.src }}"
        alt="{{ item.photo.value.alt }}"
        loading="lazy"
        [ngStyle]="{aspectRatio: item.photo?.value?.width / item.photo?.value?.height}"
      />
    </div>
    <div>
      <div class="contact-panel__item-title">
        <span *ngIf="item.firstName?.value || item.lastName?.value"
          >{{ item.firstName?.value }} {{ item.lastName?.value }}</span
        >
      </div>
      <div
        *ngIf="item.position?.value"
        class="contact-panel__item-text contact-panel__item-text-position"
      >
        {{ item.position.value }}
      </div>
      <div *ngIf="item.location?.value" class="contact-panel__item-text">
        {{ item.location.value }}
      </div>
      <address>
        <div
          *ngIf="item.email?.value"
          class="contact-panel__item-text contact-panel__item-text-mail"
        >
          <a href="mailto:{{ item.email.value }}">{{ item.email.value }}</a>
        </div>
        <div *ngIf="item.phone?.value" class="contact-panel__item-text">
          <a href="tel:{{ item.phone.value }}">{{ item.phone.value }}</a>
        </div>
      </address>
    </div>
  </div>
</div>
